import i18n from '@/utils/i18n';
import { ActionSheetContent } from './action-sheet';
import {
  DELETE_TAG_PRINT_BATCH_MUTATION,
  TAG_PRINT_BATCH_LIST_QUERY,
} from './tag-print-batch-queries';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { getOperationName } from 'apollo-utilities';
import { StyleSheet, Text } from 'react-native';
import {
  TagPrint_BatchDeleteMutation,
  TagPrint_BatchDeleteMutationVariables,
} from '@/types';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useMutation } from '@apollo/client';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  onClose: () => void;
  onDelete: () => void;
  printTagBatchUUID: string;
}

export const TagPrintBatchDeleteConfirmation: React.FC<Props> = ({
  onClose,
  onDelete,
  printTagBatchUUID,
}) => {
  const { showErrorToast } = useToasts();
  const {
    selectedRestaurantRelationship: { supplierUUID },
    selectedRestaurantUUID: restaurantUUID,
  } = useAuthenticatedUserContext();

  const [deleteBatch, { loading }] = useMutation<
    TagPrint_BatchDeleteMutation,
    TagPrint_BatchDeleteMutationVariables
  >(DELETE_TAG_PRINT_BATCH_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: [getOperationName(TAG_PRINT_BATCH_LIST_QUERY) as string],
    variables: {
      printTagBatchUUID,
      restaurantUUID,
      supplierUUID,
    },
  });

  return (
    <ActionSheetContent
      actions={[i18n.t('delete_batch'), i18n.t('cancel')]}
      loadingActionIndex={loading ? 0 : undefined}
      message={
        <Text style={[TYPOGRAPHY.p, styles.message]}>
          {i18n.t('this_action_can_not_be_undone')}
        </Text>
      }
      onAction={async (_, index) => {
        if (index === 0) {
          try {
            const response = await deleteBatch();
            if (response.data?.deletePrintTagBatchesForRestaurant.success) {
              onDelete();
            }
          } catch {
            showErrorToast();
          }
        } else {
          onClose();
        }
      }}
      title={i18n.t('batch_print_tags.delete_title')}
      titleStyle={[
        TYPOGRAPHY.navigationTitle,
        FONTS.primarySemiBold,
        styles.title,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  message: {
    marginBottom: 24,
  },
  title: {
    textAlign: 'left',
  },
});
